import { render, staticRenderFns } from "./myFileDia.vue?vue&type=template&id=e627513e&scoped=true"
import script from "./myFileDia.vue?vue&type=script&lang=js"
export * from "./myFileDia.vue?vue&type=script&lang=js"
import style0 from "./myFileDia.vue?vue&type=style&index=0&id=e627513e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e627513e",
  null
  
)

export default component.exports